/**
 * 倒计时 mixin
 * 使用方式：
 *   mixins: [countdownMixin]
 *   在 computed 中提供 countdownSeconds（剩余秒数），mixin 自动管理定时器
 *   通过 this.countdownText 获取格式化后的 HH:mm:ss 字符串
 *   倒计时结束时会 emit 'countdown-end'
 */
export default {
  data() {
    return {
      countdownText: '',
      _countdownTimer: null,
      _countdownValue: 0,
    };
  },
  watch: {
    countdownSeconds: {
      immediate: true,
      handler(val) {
        this._stopCountdown();
        const seconds = Math.max(0, Math.floor(val || 0));
        if (seconds > 0) {
          this._countdownValue = seconds;
          this._startCountdown();
        } else {
          this.countdownText = '';
        }
      },
    },
  },
  beforeDestroy() {
    this._stopCountdown();
  },
  methods: {
    _startCountdown() {
      this._updateCountdownText();
      this._countdownTimer = setInterval(() => {
        this._countdownValue -= 1;
        if (this._countdownValue < 0) {
          this._stopCountdown();
          this.countdownText = '';
          this.countdownEndEvent?.();
          return;
        }
        this._updateCountdownText();
      }, 1000);
    },
    _stopCountdown() {
      if (this._countdownTimer) {
        clearInterval(this._countdownTimer);
        this._countdownTimer = null;
      }
    },
    _updateCountdownText() {
      const s = this._countdownValue;
      const hh = String(Math.floor(s / 3600)).padStart(2, '0');
      const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const ss = String(s % 60).padStart(2, '0');
      this.countdownText = `${hh}:${mm}:${ss}`;
    },
  },
};
